import { ref } from "vue";
import { defineStore } from "pinia";
import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";

export interface User {
    name: string;
    email: string;
    password: string;
    role: object
    token: string;
}

export interface AuthToken {
    token: string;
    refresh_token: string;
}


export const useAuthStore = defineStore("auth", () => {

    const errors = ref({});
    const user = ref<User>({} as User);
    const token = ref<AuthToken>({} as AuthToken);
    const isAuthenticated = ref(!!JwtService.getToken());
    const menu = ref({});

    function setAuth(authUser) {
        isAuthenticated.value = true;
        user.value = authUser.user;
        errors.value = {};
        JwtService.saveToken(authUser.token);
        menu.value = authUser.menus;
    }

    function setToken(authToken: AuthToken) {
        token.value = authToken;
        JwtService.saveToken(token.value.token);
        JwtService.saveRefreshToken(token.value.refresh_token);
        verifyAuth();
    }

    function setTokenRefresh(authToken: AuthToken) {
        token.value = authToken;
        JwtService.saveToken(token.value.token);
        verifyAuth();
    }

    function setError(error: any) {
        errors.value = error;
    }

    function purgeAuth() {
        isAuthenticated.value = false;
        user.value = {} as User;
        errors.value = [];
        JwtService.destroyToken();
    }

    function login(credentials: User) {
        return ApiService.post("auth", credentials)
            .then(({ data }) => {
                setToken(data.data);
            })
            .catch(({ response }) => {
                setError(response.data.data);
            });
    }

    function logout() {
        purgeAuth();
    }

    async function register(credentials: any) {
        return ApiService.post("auth/register", credentials);
    }

    // function forgotPassword(email: string) {
    //     return ApiService.post("forgot_password", email)
    //         .then(() => {
    //             setError({});
    //         })
    //         .catch(({ response }) => {
    //             setError(response.data.errors);
    //         });
    // }

    async function verifyAuth() {
        if (JwtService.getToken()) {
            ApiService.setHeader();
            await ApiService.post("auth/verify", { api_token: JwtService.getToken() })
                .then(async ({ data }) => {
                    setAuth(data.data);
                })
                .catch(async ({ response }) => {
                    // await refreshToken();
                    setError(response.data.data);
                    purgeAuth();
                });
        } else {
            purgeAuth();
        }
    }

    async function refreshToken() {
        if (JwtService.getToken()) {
            ApiService.setHeader();
            await ApiService.post("auth/refresh", {
                refresh_token: JwtService.getRefreshToken(),
                email: user.value.email
            })
                .then(({ data }) => {
                    setToken(data.data);
                })
                .catch(({ response }) => {
                    setError(response.data.data);
                    purgeAuth();
                });
        } else {
            purgeAuth();
        }
    }

    function setMenu(menuData) {
        menu.value = menuData;
    }

    async function verifyEmail(verify_token: string) {
        return ApiService.post("auth/verify-email", { verify_token });
    }

    async function validateTTE(uuid: any) {
        const params = {
            uuid: uuid
        }
        return ApiService.post("permohonan-suket/tte-validation", params);
    }
    async function validateSuket(uuid: any) {
        const params = {
            uuid: uuid
        }
        return ApiService.post("permohonan-suket/docs-validation", params);
    }
    async function forgotPassword(params:any) {
        ApiService.setHeader();
        return ApiService.post("auth/forgot-password", params);
    }

    async function resetPassword(params:any) {
        ApiService.setHeader();
        return ApiService.post("auth/reset-password", params);
    }

    async function getProfile() {
        ApiService.setHeader();
        return ApiService.get("auth/profile");
    }

    return {
        errors,
        user,
        isAuthenticated,
        login,
        logout,
        register,
        forgotPassword,
        verifyAuth,
        refreshToken,
        menu,
        verifyEmail,
        validateTTE,
        validateSuket,
        resetPassword,
        getProfile,
    };
});
